<template>
    <pm-app-component hide-sidebar :hideFooter="hideFooter">
        <template slot="mobile-toolbar">
            <pm-application-bar simple>
                <slot name="title"></slot>
            </pm-application-bar>
        </template>

        <pm-app-loading-content-indicator v-if="loading" />

        <div v-if="!loading" id="main-container" class="app-content-container grey lighten-5" style="padding: 0!important;">
            <slot></slot>
        </div>

    </pm-app-component>
</template>

<script>
import PmAppComponent from "../core/pm-app-component";
import ToolbarMixin from "../../extensions/mixins/mixin-toolbar";

export default {
    components: {PmAppComponent},
    mixins: [
        ToolbarMixin,
    ],
    props: {
        toolbarBack: {
        },
        hideFooter: {
            type: Boolean,
            default: false,
        },
    },
    data: () => {
        return ({
            loading: false,
        });
    },
    toolbar() {
        const items = [];

        items.push({ placeholder: true });

        items.push({ placeholder: true });

        items.push({ placeholder: true });

        items.push({
            back: true,
            disabled: false,
            callback: () => {
                if (typeof this.toolbarBack === "function") this.toolbarBack();
                else this.$router.push("/");
            },
        });

        return ([items]);
    },
    mounted() {

    },
    methods: {

    },
};
</script>
